export default __webpack_public_path__ + "static/media/icon-favourite-unclick.d2275804.svg";